import MainHeader from "../components/MainHeader/MainHeader";
import MainAbout from "../components/MainAbout/MainAbout";
import MainShare from "../components/MainShare/MainShare";
import HowItWorks from "../components/HowItWorks/HowItWorks";
import TutorialPreview from "../components/TutorialPreview/TutorialPreview";
import JoinCommunity from "../components/JoinCommunity/JoinCommunity";
import NewsSection from "../components/NewsSection/NewsSection";
import { Helmet } from "react-helmet-async";

const MainPagePreview = () => {
  return (
    <>
      <Helmet>
        <title>Distortion Grids Database – Main</title>
        <meta
          name="description"
          content="Distortion Grids Database by Matchmove machine – ready-to-use lens grids and presets for precise 3D camera calibration in VFX and matchmoving."
        />
      </Helmet>
      <MainHeader />
      <MainAbout />
      <MainShare />
      <HowItWorks />
      <TutorialPreview />
      <NewsSection />
      <JoinCommunity />
    </>
  );
};

export default MainPagePreview;
